// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_AvailableRecebimentosForAdvancesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /payroll/available_recebimentos_for_advances/{period_id}
 *
 * Returns a list of available cash recebimentos for advances in a period.
 * Filtered by: CASH payments, operators with commission_over_execution rules,
 * and not already selected as advances.
 *
 * @see Payroll::available_recebimentos_for_advances() controller
 * @see Payroll_advances_model::getAvailableRecebimentos() source query
 */
import type { Payroll_AvailableRecebimentosForAdvancesRow } from './Payroll_AvailableRecebimentosForAdvancesRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Payroll_AvailableRecebimentosForAdvancesResponseDados = Payroll_AvailableRecebimentosForAdvancesRow[];

export type Payroll_AvailableRecebimentosForAdvancesResponse = ApiResponse<Payroll_AvailableRecebimentosForAdvancesResponseDados>;

registerResponseContract('Payroll_AvailableRecebimentosForAdvancesResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      recebimento_id:                 { type: 'number',  required: true },
      recebimento_data:               { type: 'string',  required: false },
      recebimento_valor:              { type: 'number',  required: false },
      recebimento_forma_pagamento_id: { type: 'number',  required: false },
      forma_pagamento_nome:           { type: 'string',  required: true },
      compromisso_id:                 { type: 'number',  required: true },
      operador_user_id:               { type: 'string',  required: true },
      cliente_nome:                   { type: 'string',  required: false },
      amount:                         { type: 'number',  required: true },
    },
  },
})
